import { Address } from '../services/api';

/**
 * Checks if the proposer's address matches the overnight address
 * @returns true if the overnight address is different ot the proposer address
 */
const hasOverNightAddress = (address: Address, overnightAddress: Address): boolean => {
	if (!address || !overnightAddress) return false;
	const keys: (keyof Address)[] = ['line1', 'postcode'];
	return keys.some((key) => (address[key] ?? '') !== (overnightAddress[key] ?? ''));
};

export default hasOverNightAddress;
